import React from 'react'
import { Container } from 'react-bootstrap'
import { Fragment } from 'react'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useEffect } from 'react'
// import { NavLink } from 'react-router-dom' // Uncomment when FAQ is needed

const Navbar = () => {

    let location = useLocation();
    const [ToogleMenuResponsive, setToogleMenuResponsive] = useState(false);
    const [navabarScroll, setnavabarScroll] = useState(false)

    const stickNavabr = () => {
        if (window.scrollY > 100) {
            setnavabarScroll(true)
        } else {
            setnavabarScroll(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', stickNavabr);
    }, [location])
    return (
        <Fragment>

            <div className={"fixed h-full w-full bg-MsoftYellow z-[99] pt-[100px] menuMobile " + (ToogleMenuResponsive ? "active" : "")}>
                <Container className='h-full'>
                    <ul className='list-none p-0 m-0 flex items-center flex-wrap gap-4 text-[20px] w-full'>
                        <li className='w-full'>
                            <a href="#home" onClick={() => setToogleMenuResponsive(!ToogleMenuResponsive)} className='font-medium text-Mblack'>Home</a>
                        </li>
                        <li className='w-full'>
                            <a href="#about" onClick={() => setToogleMenuResponsive(!ToogleMenuResponsive)} className='font-medium text-Mblack'>About</a>
                        </li>
                        <li className='w-full'>
                            <a href="#contact" onClick={() => setToogleMenuResponsive(!ToogleMenuResponsive)} className='font-medium text-Mblack'>Contact</a>
                        </li>
                        {/* <li className='w-full'>
                            <NavLink to="/faq" onClick={() => setToogleMenuResponsive(!ToogleMenuResponsive)} className='font-medium text-Mblack'>FAQ</NavLink>
                        </li> */}

                    </ul>
                </Container>
            </div>

            <div className={'fixed py-2 w-full z-[999] left-0 top-0 ' + (navabarScroll ? "bg-MsoftYellow" : ToogleMenuResponsive ? "bg-MsoftYellow" : "bg-transparent")}>
                <Container className='relative flex items-center'>


                    <a href="#home" className=''>
                        <img src="./assets/pantria/web_logo.png" alt="Pantria" className="w-auto object-contain h-8" />
                    </a>


                    <ul className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 list-none p-0 m-0 hidden lg:flex items-center gap-6 text__16'>
                        <li>
                            <a href="#home" className={'font-medium ' + (navabarScroll ? "text-Mblack" : "text-Mblack")}>Home</a>
                        </li>
                        <li>
                            <a href="#about" className={'font-medium ' + (navabarScroll ? "text-Mblack" : "text-Mblack")}>About</a>
                        </li>
                        <li>
                            <a href="#contact" className={'font-medium ' + (navabarScroll ? "text-Mblack" : "text-Mblack")}>Contact</a>
                        </li>
                        {/* <li>
                            <NavLink to="/faq" className={'font-medium ' + (navabarScroll ? "text-Mblack" : "text-Mblack")}>FAQ</NavLink>
                        </li> */}
                    </ul>


                    <div className="flex items-center ml-auto gap-3">

                        <div onClick={() => setToogleMenuResponsive(!ToogleMenuResponsive)} className={"relative px-1 py-1 barIcon w-[30px] h-[30px] cursor-pointer lg:hidden ml-auto " + (ToogleMenuResponsive ? "active" : "")}>
                            <div className={(navabarScroll ? "!bg-Mblack" : ToogleMenuResponsive ? "!bg-Mblack" : "!bg-Mblack")}></div>
                            <div className={(navabarScroll ? "!bg-Mblack" : ToogleMenuResponsive ? "!bg-Mblack" : "!bg-Mblack")}></div>
                            <div className={(navabarScroll ? "!bg-Mblack" : ToogleMenuResponsive ? "!bg-Mblack" : "!bg-Mblack")}></div>
                        </div>
                    </div>
                </Container>
            </div>
        </Fragment>
    )
}

export default Navbar
